module.exports = __webpack_public_path__ + "static/media/lisy.ae911c67.jpg";